import React from 'react';

const Backdrop = (props) => {
	return props.show ? (
		<div
			style={{
				position: 'fixed',
				top: '0',
				left: '0',
				width: '100%',
				height: '100vh',
				zIndex: '100',
				pointerEvents: 'none',
				background: 'rgba(0, 0, 0, 0.50)',
			}}
			onClick={props.clicked}
		></div>
	) : null;
};

export default Backdrop;
